import 'Components/vm-slider/vm-slider';
import { html, LitElement } from 'lit';
import Styles from './vm-video-chapters.scss';

export default class VmVideoChapters extends LitElement {
    static styles = Styles;

    static properties = {
        activeChapterIndex: { type: Number, attribute: 'active-chapter-index' },
    };

    constructor() {
        super();
        this.activeChapterIndex = 0;
    }

    render() {
        return html`
            <div class="video-chapters-title">Topics in this Video</div>
            <vm-slider class="video-chapters-slider" .activeIndex="${this.activeChapterIndex}">
                <slot></slot>
            </vm-slider>
        `;
    }
}

customElements.define('vm-video-chapters', VmVideoChapters);
